// MLB supplements — extended valuation history (1998-2018) + factor narratives
// Sources: Forbes annual MLB valuations (1998-2018), Sportico, ESPN, SBJ
// Forbes began publishing MLB team valuations in 1998. Pre-2010 figures are well-documented for top tier;
// mid/small market teams have more interpolation noted via isEstimated: true.
export const mlbSupplements = {

  "New York Yankees": {
    extendedValuationHistory: [
      { year: 1998, value: 0.491, source: "Forbes" },
      { year: 1999, value: 0.548, source: "Forbes", isEstimated: true },
      { year: 2000, value: 0.635, source: "Forbes" },
      { year: 2001, value: 0.730, source: "Forbes", isEstimated: true },
      { year: 2002, value: 0.849, source: "Forbes" },
      { year: 2003, value: 0.832, source: "Forbes" },
      { year: 2004, value: 0.950, source: "Forbes" },
      { year: 2005, value: 1.026, source: "Forbes" },
      { year: 2006, value: 1.200, source: "Forbes" },
      { year: 2007, value: 1.300, source: "Forbes" },
      { year: 2008, value: 1.306, source: "Forbes" },
      { year: 2009, value: 1.500, source: "Forbes" },
      { year: 2010, value: 1.600, source: "Forbes" },
      { year: 2011, value: 1.700, source: "Forbes" },
      { year: 2012, value: 1.850, source: "Forbes" },
      { year: 2013, value: 2.300, source: "Forbes" },
      { year: 2014, value: 2.500, source: "Forbes" },
      { year: 2015, value: 3.200, source: "Forbes" },
      { year: 2016, value: 3.400, source: "Forbes" },
      { year: 2017, value: 3.700, source: "Forbes" },
      { year: 2018, value: 4.000, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Yankees own ~26% of YES Network — captures both rights fee AND distribution margin in a way no other MLB team does; ~$57M/yr national share is small relative to YES economics, which has weathered the Diamond Sports collapse far better than most RSNs.",
      stadium: "Yankee Stadium (2009, $2.3B) is privately financed, team-owned with no naming rights deal (deliberate brand preservation); Legends suite and premium hospitality drive industry-leading per-cap revenue.",
      brand: "Most valuable brand in baseball; 27 World Series championships; truly global fanbase with significant international merchandise; iconic interlocking 'NY' functions as a luxury sports brand.",
      marketSize: "Largest market in MLB shared with Mets; corporate sponsorship base unmatched in baseball; tri-state DMA exceeds 20M.",
      onField: "Aaron Judge 9yr/$360M is the franchise cornerstone; consistent playoff contender but a championship drought since 2009 weighs against the brand premium.",
    },
  },

  "Boston Red Sox": {
    extendedValuationHistory: [
      { year: 1998, value: 0.213, source: "Forbes" },
      { year: 1999, value: 0.256, source: "Forbes", isEstimated: true },
      { year: 2000, value: 0.339, source: "Forbes" },
      { year: 2001, value: 0.426, source: "Forbes", isEstimated: true },
      { year: 2002, value: 0.488, source: "Forbes" },
      { year: 2003, value: 0.533, source: "Forbes" },
      { year: 2004, value: 0.563, source: "Forbes" },
      { year: 2005, value: 0.617, source: "Forbes" },
      { year: 2006, value: 0.724, source: "Forbes" },
      { year: 2007, value: 0.816, source: "Forbes" },
      { year: 2008, value: 0.833, source: "Forbes" },
      { year: 2009, value: 0.870, source: "Forbes" },
      { year: 2010, value: 0.870, source: "Forbes" },
      { year: 2011, value: 0.912, source: "Forbes" },
      { year: 2012, value: 1.000, source: "Forbes" },
      { year: 2013, value: 1.312, source: "Forbes" },
      { year: 2014, value: 1.500, source: "Forbes" },
      { year: 2015, value: 2.100, source: "Forbes" },
      { year: 2016, value: 2.300, source: "Forbes" },
      { year: 2017, value: 2.700, source: "Forbes" },
      { year: 2018, value: 2.800, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "FSG owns ~80% of NESN — vertically integrated regional rights with shared programming across Bruins; insulated from Diamond Sports collapse; long-term cord-cutting is the watch item.",
      stadium: "Fenway Park (1912) is the oldest and smallest park in MLB but generates premium-per-cap due to Green Monster mystique, Sox brand, and surrounding Fenway/Kenmore real estate footprint owned by FSG.",
      brand: "Cult-status brand with 'Curse-broken' equity from 2004; deep New England regional loyalty; fourth in MLB merch behind Yankees, Dodgers, Cubs.",
      marketSize: "Sixth-largest US DMA but unrivaled six-state regional dominance (no competing AL team in New England); premium corporate sponsor base.",
      onField: "Devers traded to Giants Jan 2025 reset payroll structure; 4 World Series since 2004 is the modern dynasty narrative even as the post-2018 window has cooled.",
    },
  },

  "Toronto Blue Jays": {
    extendedValuationHistory: [
      { year: 1998, value: 0.140, source: "Forbes" },
      { year: 2000, value: 0.162, source: "Forbes" },
      { year: 2002, value: 0.182, source: "Forbes" },
      { year: 2004, value: 0.169, source: "Forbes" },
      { year: 2006, value: 0.286, source: "Forbes" },
      { year: 2008, value: 0.353, source: "Forbes" },
      { year: 2010, value: 0.326, source: "Forbes" },
      { year: 2012, value: 0.337, source: "Forbes" },
      { year: 2014, value: 0.610, source: "Forbes" },
      { year: 2015, value: 0.870, source: "Forbes" },
      { year: 2016, value: 0.970, source: "Forbes" },
      { year: 2017, value: 1.300, source: "Forbes" },
      { year: 2018, value: 1.350, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Rogers Communications owns 100% — vertically integrated through Sportsnet; intracompany pricing depresses reported revenue but captures the full distribution margin upstream.",
      stadium: "Rogers Centre (1989) — Rogers-owned; mid-renovation $300M+ overhaul (2023-25) modernizing concourses, adding premium seating; iconic but aging.",
      brand: "Only MLB team in Canada — entire country is the addressable market; merchandise sales spike during contention windows (Vlad Jr era).",
      marketSize: "GTA market alone ≈7M; effective national reach; advertiser premium for Canada-only inventory.",
      onField: "Vlad Guerrero Jr 14yr/$500M extension (2025) is the franchise anchor; back-to-back postseason underperformance vs. high payroll has been the value drag.",
    },
  },

  "Tampa Bay Rays": {
    extendedValuationHistory: [
      { year: 1998, value: 0.180, source: "Forbes", isEstimated: true },
      { year: 2000, value: 0.150, source: "Forbes" },
      { year: 2002, value: 0.142, source: "Forbes" },
      { year: 2004, value: 0.152, source: "Forbes" },
      { year: 2006, value: 0.209, source: "Forbes" },
      { year: 2008, value: 0.290, source: "Forbes" },
      { year: 2010, value: 0.316, source: "Forbes" },
      { year: 2012, value: 0.323, source: "Forbes" },
      { year: 2014, value: 0.485, source: "Forbes" },
      { year: 2015, value: 0.625, source: "Forbes" },
      { year: 2016, value: 0.650, source: "Forbes" },
      { year: 2017, value: 0.825, source: "Forbes" },
      { year: 2018, value: 0.900, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Direct streaming pivot following Bally Sports collapse; modest local rights fees offset by national share + analytics-driven cost discipline.",
      stadium: "Tropicana Field roof destroyed by Hurricane Milton Oct 2024 — playing 2025 at Steinbrenner Field (Yankees spring complex); planned $1.3B St. Pete ballpark is now uncertain after Sternberg sale to Zalupski group at $1.7B+.",
      brand: "Smallest brand footprint in MLB; analytics-organization halo helps merchandise but no national draw outside core fans.",
      marketSize: "St. Pete/Tampa DMA #11 by population but split with Bucs/Lightning; bridge logistics suppress weekday attendance.",
      onField: "Consistent contender on bottom-quartile payroll; 2020 pennant + 2008 World Series appearance proves player-development model; no franchise centerpiece contract.",
    },
  },

  "Baltimore Orioles": {
    extendedValuationHistory: [
      { year: 1998, value: 0.351, source: "Forbes" },
      { year: 2000, value: 0.319, source: "Forbes" },
      { year: 2002, value: 0.319, source: "Forbes" },
      { year: 2004, value: 0.295, source: "Forbes" },
      { year: 2006, value: 0.395, source: "Forbes" },
      { year: 2008, value: 0.398, source: "Forbes" },
      { year: 2010, value: 0.376, source: "Forbes" },
      { year: 2012, value: 0.460, source: "Forbes" },
      { year: 2014, value: 0.620, source: "Forbes" },
      { year: 2015, value: 1.000, source: "Forbes" },
      { year: 2016, value: 1.000, source: "Forbes" },
      { year: 2017, value: 1.175, source: "Forbes" },
      { year: 2018, value: 1.200, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "MASN dispute with Nationals (rights fee arbitration) has dragged for 20 years and continues to depress Orioles reported local revenue; Rubenstein acquisition (2024) brings new energy but settlement remains pending.",
      stadium: "Camden Yards (1992) reset the modern ballpark template; long-term lease being renegotiated under Rubenstein with development rights to surrounding land — the real estate optionality is the upside case.",
      brand: "Strong regional brand from 60s-80s dynasty + Camden Yards aesthetics; Cal Ripken Jr legacy still drives merchandise.",
      marketSize: "Baltimore DMA #28 but functionally splits Mid-Atlantic with Nationals; corporate base smaller than peer markets.",
      onField: "Adley Rutschman + Gunnar Henderson + Jackson Holliday core promises a contention window 2024-2030; 2014 was last division title, 1983 last World Series — the rebuild has finally produced.",
    },
  },

  "Chicago White Sox": {
    extendedValuationHistory: [
      { year: 1998, value: 0.214, source: "Forbes" },
      { year: 2000, value: 0.178, source: "Forbes" },
      { year: 2002, value: 0.223, source: "Forbes" },
      { year: 2004, value: 0.248, source: "Forbes" },
      { year: 2006, value: 0.381, source: "Forbes" },
      { year: 2008, value: 0.450, source: "Forbes" },
      { year: 2010, value: 0.526, source: "Forbes" },
      { year: 2012, value: 0.600, source: "Forbes" },
      { year: 2014, value: 0.692, source: "Forbes" },
      { year: 2015, value: 0.975, source: "Forbes" },
      { year: 2016, value: 1.050, source: "Forbes" },
      { year: 2017, value: 1.350, source: "Forbes" },
      { year: 2018, value: 1.500, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Reinsdorf-controlled CHSN launched 2024 from ashes of Bally Sports Chicago — White Sox + Bulls + Blackhawks shared equity stake gives long-term distribution upside if streaming subscription scales.",
      stadium: "Guaranteed Rate Field (1991) is publicly owned (ISFA), state-backed; new South Loop downtown stadium proposal under negotiation — Reinsdorf has signaled intent to relocate.",
      brand: "Second-fiddle to Cubs in Chicago; 2005 World Series is the only post-1917 title; merchandise indexes well below market peer.",
      marketSize: "Third-largest US DMA but Cubs capture the larger share; corporate base is large but hostility-split.",
      onField: "Worst MLB record in 2024 (41-121, 121-loss season); Robert/Crochet trade speculation in offseason; rebuild pre-Reinsdorf-Ishbia ownership transition (2029-2034 option).",
    },
  },

  "Cleveland Guardians": {
    extendedValuationHistory: [
      { year: 1998, value: 0.359, source: "Forbes" },
      { year: 2000, value: 0.372, source: "Forbes" },
      { year: 2002, value: 0.360, source: "Forbes" },
      { year: 2004, value: 0.292, source: "Forbes" },
      { year: 2006, value: 0.352, source: "Forbes" },
      { year: 2008, value: 0.399, source: "Forbes" },
      { year: 2010, value: 0.353, source: "Forbes" },
      { year: 2012, value: 0.392, source: "Forbes" },
      { year: 2014, value: 0.570, source: "Forbes" },
      { year: 2015, value: 0.825, source: "Forbes" },
      { year: 2016, value: 0.800, source: "Forbes" },
      { year: 2017, value: 0.945, source: "Forbes" },
      { year: 2018, value: 1.045, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports Great Lakes evicted; team transitioning to direct + over-the-air model; Blitzer minority stake brings sophisticated capital and 2028 majority option.",
      stadium: "Progressive Field (1994) — county-owned, modest renovations; lease through 2036 with extension; not a development-driven asset.",
      brand: "Strong regional brand from 90s contention era; rebrand from Indians (2022) was contentious; José Ramírez face-of-franchise.",
      marketSize: "Cleveland DMA #19; declining metro population is a structural headwind for ticket and corporate revenue.",
      onField: "Ramírez 7yr/$124M is one of MLB's best contracts; Cy Young winner Tarik Skubal level pitching depth; 2024 ALCS run reignited the long-window value story.",
    },
  },

  "Detroit Tigers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.137, source: "Forbes" },
      { year: 2000, value: 0.152, source: "Forbes" },
      { year: 2002, value: 0.235, source: "Forbes" },
      { year: 2004, value: 0.243, source: "Forbes" },
      { year: 2006, value: 0.292, source: "Forbes" },
      { year: 2008, value: 0.371, source: "Forbes" },
      { year: 2010, value: 0.375, source: "Forbes" },
      { year: 2012, value: 0.643, source: "Forbes" },
      { year: 2014, value: 0.680, source: "Forbes" },
      { year: 2015, value: 1.125, source: "Forbes" },
      { year: 2016, value: 1.150, source: "Forbes" },
      { year: 2017, value: 1.200, source: "Forbes" },
      { year: 2018, value: 1.225, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports Detroit relationship transitioning post-Diamond bankruptcy; team-controlled streaming pivot underway; long-term local rights value is league-average.",
      stadium: "Comerica Park (2000) — public-private; naming rights transitioning to Fifth Third Bank after 2026; team owned via Ilitch Holdings with adjacent District Detroit development.",
      brand: "Olde English D is one of MLB's iconic logos; 11 pennants and 4 World Series tied to historic franchise depth.",
      marketSize: "Detroit DMA #14; corporate base dominated by automakers — cyclical exposure to Big Three is a soft factor.",
      onField: "Skubal 2024 Cy Young; Larkin captaincy era; 2024 wild card run validates 'rebuild complete' thesis under Scott Harris/AJ Hinch leadership.",
    },
  },

  "Kansas City Royals": {
    extendedValuationHistory: [
      { year: 1998, value: 0.108, source: "Forbes" },
      { year: 2000, value: 0.122, source: "Forbes", isEstimated: true },
      { year: 2002, value: 0.152, source: "Forbes" },
      { year: 2004, value: 0.171, source: "Forbes" },
      { year: 2006, value: 0.239, source: "Forbes" },
      { year: 2008, value: 0.301, source: "Forbes" },
      { year: 2010, value: 0.341, source: "Forbes" },
      { year: 2012, value: 0.354, source: "Forbes" },
      { year: 2014, value: 0.490, source: "Forbes" },
      { year: 2015, value: 0.700, source: "Forbes" },
      { year: 2016, value: 0.865, source: "Forbes" },
      { year: 2017, value: 0.950, source: "Forbes" },
      { year: 2018, value: 1.015, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "FanDuel Sports Network (former Bally) deal restructured 2024; team exploring direct streaming; revenue-sharing dependency limits media upside.",
      stadium: "Kauffman Stadium (1973) — Jackson County owned; lease expired and team negotiating new $1.9B Crown Center downtown ballpark; relocation/financing fight is the major near-term valuation event.",
      brand: "Modest national brand outside 2014-15 World Series window; strong heartland regional loyalty.",
      marketSize: "Kansas City DMA #34 — small market; revenue-sharing recipient with ~$60M+ annual transfer.",
      onField: "Bobby Witt Jr 11yr/$288.8M is the franchise nucleus; 2024 wild card run rebuilt fan engagement after 2018-2023 desert period.",
    },
  },

  "Minnesota Twins": {
    extendedValuationHistory: [
      { year: 1998, value: 0.094, source: "Forbes" },
      { year: 2000, value: 0.099, source: "Forbes" },
      { year: 2002, value: 0.127, source: "Forbes" },
      { year: 2004, value: 0.168, source: "Forbes" },
      { year: 2006, value: 0.216, source: "Forbes" },
      { year: 2008, value: 0.328, source: "Forbes" },
      { year: 2010, value: 0.405, source: "Forbes" },
      { year: 2012, value: 0.510, source: "Forbes" },
      { year: 2014, value: 0.605, source: "Forbes" },
      { year: 2015, value: 0.895, source: "Forbes" },
      { year: 2016, value: 0.910, source: "Forbes" },
      { year: 2017, value: 1.025, source: "Forbes" },
      { year: 2018, value: 1.150, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports North bankruptcy disrupted local TV; Twins now on Twins.TV direct streaming + over-the-air; revenue concession material.",
      stadium: "Target Field (2010) — Hennepin County funded ($392M public); lease through 2059; team retains operations and naming.",
      brand: "Mid-tier brand; '87 and '91 World Series titles drive Gen X loyalty; merchandise indexes near league median.",
      marketSize: "Minneapolis-St. Paul DMA #15; strong corporate base (Target, US Bank, 3M, UnitedHealth) but no rival pro sports team to anchor.",
      onField: "Buxton oft-injured; Correa contract restructured after physical concerns; 2023 division win + wild card series sweep flipped the playoff-drought narrative; Pohlad family explored sale 2024 then reversed.",
    },
  },

  "Houston Astros": {
    extendedValuationHistory: [
      { year: 1998, value: 0.220, source: "Forbes" },
      { year: 2000, value: 0.319, source: "Forbes" },
      { year: 2002, value: 0.337, source: "Forbes" },
      { year: 2004, value: 0.357, source: "Forbes" },
      { year: 2006, value: 0.416, source: "Forbes" },
      { year: 2008, value: 0.463, source: "Forbes" },
      { year: 2010, value: 0.453, source: "Forbes" },
      { year: 2012, value: 0.474, source: "Forbes" },
      { year: 2014, value: 0.530, source: "Forbes" },
      { year: 2015, value: 0.800, source: "Forbes" },
      { year: 2016, value: 0.900, source: "Forbes" },
      { year: 2017, value: 1.450, source: "Forbes" },
      { year: 2018, value: 1.650, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Crane owns Space City Home Network alongside Rockets — vertically integrated regional with NBA cross-promotion; structural moat against Diamond Sports collapse.",
      stadium: "Daikin Park (formerly Minute Maid Park, renamed Jan 2025) — public-private partnership; downtown location with Astros-owned adjacent development.",
      brand: "2017-2022 contention dynasty + 2017 sign-stealing scandal cuts both ways; strong Texas regional brand; orange-and-blue palette resonates.",
      marketSize: "Houston DMA #7 — large, fast-growing; energy corporate base but cyclical exposure.",
      onField: "Two World Series in last 10 years (2017, 2022); Altuve / Alvarez core; sustained playoff appearances 2015-2024 anchor brand premium.",
    },
  },

  "Los Angeles Angels": {
    extendedValuationHistory: [
      { year: 1998, value: 0.157, source: "Forbes" },
      { year: 2000, value: 0.195, source: "Forbes" },
      { year: 2002, value: 0.225, source: "Forbes" },
      { year: 2004, value: 0.241, source: "Forbes" },
      { year: 2006, value: 0.368, source: "Forbes" },
      { year: 2008, value: 0.500, source: "Forbes" },
      { year: 2010, value: 0.521, source: "Forbes" },
      { year: 2012, value: 0.554, source: "Forbes" },
      { year: 2014, value: 0.775, source: "Forbes" },
      { year: 2015, value: 1.300, source: "Forbes" },
      { year: 2016, value: 1.350, source: "Forbes" },
      { year: 2017, value: 1.750, source: "Forbes" },
      { year: 2018, value: 1.800, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports West relationship in flux; 17-year, $3B Fox Sports deal signed 2012 still anchors local revenue; transition to direct distribution underway.",
      stadium: "Angel Stadium (1966) — city of Anaheim owned; lease expires 2029; Moreno's stadium-land sale-and-redevelopment plan collapsed in court — ongoing real-estate value optionality unresolved.",
      brand: "Halo logo retains regional equity; second-team-in-LA market position caps national reach; 2002 World Series the lone modern title.",
      marketSize: "LA DMA #2 but split with Dodgers; Orange County corporate base material but secondary.",
      onField: "Trout / Rendon contracts have been injury-burdened albatrosses; post-Ohtani era began Nov 2023; sustained losing erodes the franchise premium.",
    },
  },

  "Oakland Athletics": {
    extendedValuationHistory: [
      { year: 1998, value: 0.118, source: "Forbes" },
      { year: 2000, value: 0.149, source: "Forbes" },
      { year: 2002, value: 0.157, source: "Forbes" },
      { year: 2004, value: 0.180, source: "Forbes" },
      { year: 2006, value: 0.234, source: "Forbes" },
      { year: 2008, value: 0.319, source: "Forbes" },
      { year: 2010, value: 0.295, source: "Forbes" },
      { year: 2012, value: 0.321, source: "Forbes" },
      { year: 2014, value: 0.495, source: "Forbes" },
      { year: 2015, value: 0.725, source: "Forbes" },
      { year: 2016, value: 0.880, source: "Forbes" },
      { year: 2017, value: 1.000, source: "Forbes" },
      { year: 2018, value: 1.020, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "NBC Sports California deal continues despite relocation; modest local rights; Las Vegas relocation projected to materially reset media economics post-2028.",
      stadium: "Sutter Health Park (Sacramento) interim 2025-2027; Las Vegas $1.75B Tropicana site stadium under construction for 2028; relocation premium drove 50%+ Forbes valuation jump.",
      brand: "Moneyball / Beane era cult brand; relocation has fractured Oakland fanbase; Vegas market positioning untested.",
      marketSize: "Oakland-SF DMA being abandoned (#9); Las Vegas DMA #40 but tourism-driven attendance model planned.",
      onField: "Sustained losing under Fisher's payroll cuts; rebuild lacks a marquee anchor; relocation upside is a bet on Vegas market emergence.",
    },
  },

  "Seattle Mariners": {
    extendedValuationHistory: [
      { year: 1998, value: 0.236, source: "Forbes" },
      { year: 2000, value: 0.332, source: "Forbes" },
      { year: 2002, value: 0.373, source: "Forbes" },
      { year: 2004, value: 0.385, source: "Forbes" },
      { year: 2006, value: 0.428, source: "Forbes" },
      { year: 2008, value: 0.426, source: "Forbes" },
      { year: 2010, value: 0.439, source: "Forbes" },
      { year: 2012, value: 0.585, source: "Forbes" },
      { year: 2014, value: 0.710, source: "Forbes" },
      { year: 2015, value: 1.100, source: "Forbes" },
      { year: 2016, value: 1.200, source: "Forbes" },
      { year: 2017, value: 1.400, source: "Forbes" },
      { year: 2018, value: 1.450, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "ROOT Sports NW is team-controlled — survived Diamond Sports collapse cleanly; 71% Mariners ownership creates direct distribution upside.",
      stadium: "T-Mobile Park (1999) — public-private; team-operated; renovation funded via lease extension through 2049.",
      brand: "Strong PNW regional loyalty despite playoff drought; 2001 116-win season is the modern-era apex; rebuilt brand around pitching identity.",
      marketSize: "Seattle DMA #12 — fast-growing tech corporate base (Amazon, Microsoft); Pacific Northwest territory exclusive.",
      onField: "Julio Rodriguez 12yr/$210M franchise extension; ended 21-year playoff drought 2022; pitching factory (Castillo, Gilbert, Kirby) sustained the contention window.",
    },
  },

  "Texas Rangers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.254, source: "Forbes" },
      { year: 2000, value: 0.342, source: "Forbes" },
      { year: 2002, value: 0.356, source: "Forbes" },
      { year: 2004, value: 0.353, source: "Forbes" },
      { year: 2006, value: 0.353, source: "Forbes" },
      { year: 2008, value: 0.405, source: "Forbes" },
      { year: 2010, value: 0.451, source: "Forbes" },
      { year: 2012, value: 0.674, source: "Forbes" },
      { year: 2014, value: 0.825, source: "Forbes" },
      { year: 2015, value: 1.220, source: "Forbes" },
      { year: 2016, value: 1.250, source: "Forbes" },
      { year: 2017, value: 1.550, source: "Forbes" },
      { year: 2018, value: 1.600, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Local rights with Bally Sports Southwest in transition; Fox/MLB national TV anchors; team participates in MLB Local Media direct-to-consumer experiment.",
      stadium: "Globe Life Field (2020, $1.2B) — fully retractable roof; ~$500M public subsidy via Arlington bonds; team retains naming rights and operations.",
      brand: "Mid-tier national brand boosted materially by 2023 World Series win — first in franchise history; Texas + Mexico market crossover is structural upside.",
      marketSize: "DFW DMA #5 — large, fast-growing; corporate base diversified across energy, financial services, telecom.",
      onField: "Seager 10yr/$325M + Semien 7yr/$175M anchor 2023 title core; deGrom signed despite injury history; window through 2027.",
    },
  },

  "Atlanta Braves": {
    extendedValuationHistory: [
      { year: 1998, value: 0.299, source: "Forbes" },
      { year: 2000, value: 0.357, source: "Forbes" },
      { year: 2002, value: 0.424, source: "Forbes" },
      { year: 2004, value: 0.382, source: "Forbes" },
      { year: 2006, value: 0.405, source: "Forbes" },
      { year: 2008, value: 0.458, source: "Forbes" },
      { year: 2010, value: 0.450, source: "Forbes" },
      { year: 2012, value: 0.629, source: "Forbes" },
      { year: 2014, value: 0.730, source: "Forbes" },
      { year: 2015, value: 1.150, source: "Forbes" },
      { year: 2016, value: 1.175, source: "Forbes" },
      { year: 2017, value: 1.500, source: "Forbes" },
      { year: 2018, value: 1.625, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports South relationship in flux; team-controlled streaming pivot; Liberty Media/Atlanta Braves Holdings public listing (BATRA/BATRK) provides transparent media accounting.",
      stadium: "Truist Park (2017) + The Battery Atlanta mixed-use development — $1B+ ancillary real estate is the modern industry template; Cobb County partner; operates as a genuine entertainment district.",
      brand: "TBS superstation legacy created a national brand from 1980s-90s broadcasts; tomahawk chop controversies notwithstanding, deep South regional loyalty.",
      marketSize: "Atlanta DMA #6 — fast-growing, corporate-rich (Coke, Delta, UPS, Home Depot); Southeast territory effectively exclusive.",
      onField: "2021 World Series + 2018-2023 division streak built modern dynasty narrative; Acuña Jr / Albies / Olson / Riley / Strider core mostly under team control through 2030+.",
    },
  },

  "Miami Marlins": {
    extendedValuationHistory: [
      { year: 1998, value: 0.153, source: "Forbes" },
      { year: 2000, value: 0.128, source: "Forbes" },
      { year: 2002, value: 0.137, source: "Forbes" },
      { year: 2004, value: 0.172, source: "Forbes" },
      { year: 2006, value: 0.226, source: "Forbes" },
      { year: 2008, value: 0.256, source: "Forbes" },
      { year: 2010, value: 0.317, source: "Forbes" },
      { year: 2012, value: 0.450, source: "Forbes" },
      { year: 2014, value: 0.500, source: "Forbes" },
      { year: 2015, value: 0.650, source: "Forbes" },
      { year: 2016, value: 0.675, source: "Forbes" },
      { year: 2017, value: 0.940, source: "Forbes" },
      { year: 2018, value: 1.000, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports Florida deal restructured; modest local revenue; Latin American international rights potential underutilized.",
      stadium: "LoanDepot Park (2012, $634M) — controversial public financing left Miami-Dade with $1.2B+ debt service; retractable roof; below-MLB-average attendance.",
      brand: "Two World Series titles (1997, 2003) but rapid post-title fire sales eroded brand equity; Jeter era (2017-22) failed to build sustained engagement.",
      marketSize: "Miami DMA #16 — Latin American immigrant base is structural opportunity; competing with NFL Dolphins, NBA Heat for fan attention.",
      onField: "2023 wild card appearance was first playoff trip since 2003; Jazz Chisholm Jr traded to Yankees July 2024; rebuild ongoing under Bruce Sherman/new front office.",
    },
  },

  "New York Mets": {
    extendedValuationHistory: [
      { year: 1998, value: 0.193, source: "Forbes" },
      { year: 2000, value: 0.249, source: "Forbes" },
      { year: 2002, value: 0.482, source: "Forbes" },
      { year: 2004, value: 0.498, source: "Forbes" },
      { year: 2006, value: 0.604, source: "Forbes" },
      { year: 2008, value: 0.824, source: "Forbes" },
      { year: 2010, value: 0.858, source: "Forbes" },
      { year: 2012, value: 0.719, source: "Forbes" },
      { year: 2014, value: 0.800, source: "Forbes" },
      { year: 2015, value: 1.350, source: "Forbes" },
      { year: 2016, value: 1.650, source: "Forbes" },
      { year: 2017, value: 2.000, source: "Forbes" },
      { year: 2018, value: 2.100, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "SNY (Mets-owned cable channel) — team owns ~65% with Comcast/Time Warner partnership; one of MLB's strongest team-owned RSN positions; structural moat.",
      stadium: "Citi Field (2009, $850M) — public-private; Citigroup naming rights ~$20M/yr through 2028 (renewing); Cohen pursuing $8B Willets Point casino-and-stadium redevelopment.",
      brand: "Strong NYC alternative-fanbase identity vs. Yankees; Cohen ownership era brought new energy; Soto signing reset the brand premium.",
      marketSize: "NYC DMA #1 shared with Yankees; corporate base plus Latin American/Caribbean immigrant fanbase.",
      onField: "Juan Soto 15yr/$765M (Dec 2024) is the largest contract in pro sports history; Cohen's no-payroll-cap approach has reset franchise economics; 2024 NLCS run.",
    },
  },

  "Philadelphia Phillies": {
    extendedValuationHistory: [
      { year: 1998, value: 0.145, source: "Forbes" },
      { year: 2000, value: 0.231, source: "Forbes" },
      { year: 2002, value: 0.281, source: "Forbes" },
      { year: 2004, value: 0.281, source: "Forbes" },
      { year: 2006, value: 0.424, source: "Forbes" },
      { year: 2008, value: 0.481, source: "Forbes" },
      { year: 2010, value: 0.537, source: "Forbes" },
      { year: 2012, value: 0.723, source: "Forbes" },
      { year: 2014, value: 0.975, source: "Forbes" },
      { year: 2015, value: 1.250, source: "Forbes" },
      { year: 2016, value: 1.235, source: "Forbes" },
      { year: 2017, value: 1.650, source: "Forbes" },
      { year: 2018, value: 1.700, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "NBC Sports Philadelphia (Comcast intracompany) owns local rights — vertically integrated through Comcast Spectacor; insulated from Diamond Sports collapse.",
      stadium: "Citizens Bank Park (2004) — public-private; lease through 2032; team-operated with steady premium hospitality revenue.",
      brand: "Highly engaged 'Philly Phaithful' fanbase; second-largest single-team market east of the Mississippi; merchandise indexes well.",
      marketSize: "Philadelphia DMA #4 — corporate base diverse, Comcast HQ-anchored.",
      onField: "Harper / Schwarber / Turner / Wheeler core; 2022 NL pennant + 2023 NLCS + 2024 NLDS sustained contention; consistently top-5 payroll under Middleton ownership.",
    },
  },

  "Washington Nationals": {
    extendedValuationHistory: [
      { year: 1998, value: 0.108, source: "Forbes", isEstimated: true, _note: "Pre-2005 = Montreal Expos" },
      { year: 2000, value: 0.092, source: "Forbes", _note: "as Montreal Expos" },
      { year: 2002, value: 0.108, source: "Forbes", _note: "as Montreal Expos" },
      { year: 2004, value: 0.145, source: "Forbes", _note: "as Montreal Expos, MLB-owned" },
      { year: 2006, value: 0.440, source: "Forbes", _note: "First Forbes valuation post-DC relocation" },
      { year: 2008, value: 0.406, source: "Forbes" },
      { year: 2010, value: 0.406, source: "Forbes" },
      { year: 2012, value: 0.480, source: "Forbes" },
      { year: 2014, value: 0.700, source: "Forbes" },
      { year: 2015, value: 1.280, source: "Forbes" },
      { year: 2016, value: 1.300, source: "Forbes" },
      { year: 2017, value: 1.600, source: "Forbes" },
      { year: 2018, value: 1.675, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "MASN dispute with Orioles continues — Nationals receive significantly below market local rights; arbitration outcomes have improved post-2019 but value drag remains.",
      stadium: "Nationals Park (2008) — DC-funded ($693M public bond); team-operated; surrounding Navy Yard development area benefits team peripherally.",
      brand: "Built post-2005 relocation; 2019 World Series title is foundational equity; otherwise mid-tier national brand.",
      marketSize: "DC DMA #9 — government and lobbyist corporate base; competing with Capitals, Wizards, Caps, Commanders.",
      onField: "Post-Soto-Bell-Hernandez tear-down 2022 created multi-year rebuild; Crews/Wood/Cavalli/House young core; Lerner family explored sale 2022 then withdrew.",
    },
  },

  "Chicago Cubs": {
    extendedValuationHistory: [
      { year: 1998, value: 0.224, source: "Forbes" },
      { year: 2000, value: 0.247, source: "Forbes" },
      { year: 2002, value: 0.335, source: "Forbes" },
      { year: 2004, value: 0.398, source: "Forbes" },
      { year: 2006, value: 0.448, source: "Forbes" },
      { year: 2008, value: 0.642, source: "Forbes" },
      { year: 2010, value: 0.726, source: "Forbes" },
      { year: 2012, value: 0.879, source: "Forbes" },
      { year: 2014, value: 1.200, source: "Forbes" },
      { year: 2015, value: 1.800, source: "Forbes" },
      { year: 2016, value: 2.200, source: "Forbes" },
      { year: 2017, value: 2.675, source: "Forbes" },
      { year: 2018, value: 2.900, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Marquee Sports Network (launched 2020) — Cubs partial-ownership RSN with Sinclair partner; navigated Diamond Sports collapse through alternative structure.",
      stadium: "Wrigley Field (1914) — historic landmark; Ricketts $750M+ 'Wrigley 1060' renovation completed 2020 including Hotel Zachary, plaza, expanded clubhouse; rooftop revenue captured via 17.5% deals with adjacent buildings.",
      brand: "Lovable losers brand → curse-broken champion brand post-2016; massive national/international following; merchandise top-3.",
      marketSize: "Chicago DMA #3 — Cubs capture larger share than White Sox; corporate base dominated by financial services and consumer brands.",
      onField: "2016 World Series ended 108-year drought; subsequent Bryant/Báez/Rizzo core dispersed by 2021; 2024 wild card chase under Counsell rebuilds momentum.",
    },
  },

  "Cincinnati Reds": {
    extendedValuationHistory: [
      { year: 1998, value: 0.142, source: "Forbes" },
      { year: 2000, value: 0.138, source: "Forbes" },
      { year: 2002, value: 0.182, source: "Forbes" },
      { year: 2004, value: 0.245, source: "Forbes" },
      { year: 2006, value: 0.274, source: "Forbes" },
      { year: 2008, value: 0.337, source: "Forbes" },
      { year: 2010, value: 0.391, source: "Forbes" },
      { year: 2012, value: 0.546, source: "Forbes" },
      { year: 2014, value: 0.625, source: "Forbes" },
      { year: 2015, value: 0.885, source: "Forbes" },
      { year: 2016, value: 0.915, source: "Forbes" },
      { year: 2017, value: 1.010, source: "Forbes" },
      { year: 2018, value: 1.015, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports Ohio dependency a structural risk; Reds participating in MLB Local Media DTC pilot; modest national share.",
      stadium: "Great American Ball Park (2003) — public-funded ($290M Hamilton County); team-operated, naming through 2034.",
      brand: "Big Red Machine (1970s) heritage drives brand equity; oldest professional baseball franchise (1869); strong Ohio Valley regional loyalty.",
      marketSize: "Cincinnati DMA #36 — small market; revenue-sharing recipient; competing with Bengals for share of attention.",
      onField: "Elly De La Cruz emerged as franchise face; rebuild under Castellini ownership produced 2023 wild card race + 2024 contention.",
    },
  },

  "Milwaukee Brewers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.127, source: "Forbes" },
      { year: 2000, value: 0.155, source: "Forbes" },
      { year: 2002, value: 0.187, source: "Forbes" },
      { year: 2004, value: 0.208, source: "Forbes" },
      { year: 2006, value: 0.235, source: "Forbes" },
      { year: 2008, value: 0.331, source: "Forbes" },
      { year: 2010, value: 0.351, source: "Forbes" },
      { year: 2012, value: 0.448, source: "Forbes" },
      { year: 2014, value: 0.565, source: "Forbes" },
      { year: 2015, value: 0.875, source: "Forbes" },
      { year: 2016, value: 0.925, source: "Forbes" },
      { year: 2017, value: 1.025, source: "Forbes" },
      { year: 2018, value: 1.075, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports Wisconsin transitioning post-Diamond bankruptcy; modest local TV deal; revenue-sharing recipient offsets disadvantage.",
      stadium: "American Family Field (2001, retractable roof) — public-private; recent $500M state-supported renovation/extension package secures team to 2050; lease structure shields downside.",
      brand: "Strong regional Wisconsin loyalty; only major-league team in state (post-Bucks); Bernie the Brewer / sausage race brand quirks resonate.",
      marketSize: "Milwaukee DMA #36 — small market, but state-wide reach makes it functionally larger; corporate base modest.",
      onField: "Six straight playoff appearances (2018-2024 except 2022); Yelich franchise face; 2024 division championship shows model works under Attanasio's $130M payroll cap.",
    },
  },

  "Pittsburgh Pirates": {
    extendedValuationHistory: [
      { year: 1998, value: 0.143, source: "Forbes" },
      { year: 2000, value: 0.132, source: "Forbes" },
      { year: 2002, value: 0.215, source: "Forbes" },
      { year: 2004, value: 0.224, source: "Forbes" },
      { year: 2006, value: 0.250, source: "Forbes" },
      { year: 2008, value: 0.292, source: "Forbes" },
      { year: 2010, value: 0.289, source: "Forbes" },
      { year: 2012, value: 0.336, source: "Forbes" },
      { year: 2014, value: 0.479, source: "Forbes" },
      { year: 2015, value: 0.825, source: "Forbes" },
      { year: 2016, value: 0.975, source: "Forbes" },
      { year: 2017, value: 1.250, source: "Forbes" },
      { year: 2018, value: 1.275, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "SportsNet Pittsburgh (Pirates + Penguins JV) — partial team ownership offers structural insulation; modest local market depresses absolute fees.",
      stadium: "PNC Park (2001) — widely acclaimed as best ballpark in MLB; ~70% public-funded; lease through 2031.",
      brand: "Modest national brand; Roberto Clemente legacy strong; regional steel-town loyalty undercut by long losing stretches.",
      marketSize: "Pittsburgh DMA #28 — small market; revenue-sharing recipient; declining metro is structural headwind.",
      onField: "Paul Skenes (#1 pick 2023, 2024 Rookie of the Year) is the franchise cornerstone; Nutting payroll discipline limits upside even with star pitching.",
    },
  },

  "St. Louis Cardinals": {
    extendedValuationHistory: [
      { year: 1998, value: 0.218, source: "Forbes" },
      { year: 2000, value: 0.243, source: "Forbes" },
      { year: 2002, value: 0.271, source: "Forbes" },
      { year: 2004, value: 0.314, source: "Forbes" },
      { year: 2006, value: 0.460, source: "Forbes" },
      { year: 2008, value: 0.484, source: "Forbes" },
      { year: 2010, value: 0.488, source: "Forbes" },
      { year: 2012, value: 0.591, source: "Forbes" },
      { year: 2014, value: 0.820, source: "Forbes" },
      { year: 2015, value: 1.400, source: "Forbes" },
      { year: 2016, value: 1.600, source: "Forbes" },
      { year: 2017, value: 1.800, source: "Forbes" },
      { year: 2018, value: 1.900, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports Midwest deal restructured 2024; Cardinals exploring direct streaming; revenue-sharing recipient status protects downside.",
      stadium: "Busch Stadium (2006) — majority private financing ($310M private / $90M public); team-owned; adjacent Ballpark Village development is the modern industry template, generates ~$30M+ ancillary revenue.",
      brand: "Best-run baseball franchise narrative — 11 World Series titles (most in NL); 'Cardinals Way' brand resonates regionally and beyond; merchandise above market peer.",
      marketSize: "St. Louis DMA #21 — small absolute market but Cardinals Nation extends across Midwest/Southeast.",
      onField: "Arenado / Goldschmidt aging core; 2024 missed playoffs broke 5-year streak; rebuild watch under Mozeliak/Bloom front office transition.",
    },
  },

  "Los Angeles Dodgers": {
    extendedValuationHistory: [
      { year: 1998, value: 0.270, source: "Forbes" },
      { year: 2000, value: 0.381, source: "Forbes" },
      { year: 2002, value: 0.435, source: "Forbes" },
      { year: 2004, value: 0.424, source: "Forbes" },
      { year: 2006, value: 0.482, source: "Forbes" },
      { year: 2008, value: 0.694, source: "Forbes" },
      { year: 2010, value: 0.727, source: "Forbes" },
      { year: 2012, value: 1.400, source: "Forbes", _note: "Reflects $2.15B Guggenheim purchase" },
      { year: 2014, value: 2.000, source: "Forbes" },
      { year: 2015, value: 2.400, source: "Forbes" },
      { year: 2016, value: 2.500, source: "Forbes" },
      { year: 2017, value: 2.750, source: "Forbes" },
      { year: 2018, value: 3.000, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "SportsNet LA — 25-year, $8.35B Time Warner Cable deal (2014-2038) — largest local TV contract in baseball history; structural moat that anchors Dodger valuation premium.",
      stadium: "Dodger Stadium (1962) — team-owned (only privately-owned, no-public-money MLB stadium); Walter has invested $300M+ in renovations; surrounding land is a long-term real estate option.",
      brand: "Most-watched MLB team globally; Latin American + Asian markets drive merchandise; Ohtani signing ($700M) reset international brand power.",
      marketSize: "LA DMA #2 — Dodgers dominate vs. Angels; corporate sponsor base unmatched outside NYC; Hispanic immigrant fanbase is structural.",
      onField: "Two World Series in last 5 years (2020, 2024); Ohtani / Yamamoto / Glasnow / Betts / Freeman lineup; sustained 100+ win seasons since 2017.",
    },
  },

  "San Francisco Giants": {
    extendedValuationHistory: [
      { year: 1998, value: 0.213, source: "Forbes" },
      { year: 2000, value: 0.333, source: "Forbes" },
      { year: 2002, value: 0.355, source: "Forbes" },
      { year: 2004, value: 0.378, source: "Forbes" },
      { year: 2006, value: 0.410, source: "Forbes" },
      { year: 2008, value: 0.494, source: "Forbes" },
      { year: 2010, value: 0.483, source: "Forbes" },
      { year: 2012, value: 0.643, source: "Forbes" },
      { year: 2014, value: 1.000, source: "Forbes" },
      { year: 2015, value: 2.000, source: "Forbes" },
      { year: 2016, value: 2.250, source: "Forbes" },
      { year: 2017, value: 2.650, source: "Forbes" },
      { year: 2018, value: 2.850, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "NBC Sports Bay Area — Comcast partial ownership creates structural insulation against RSN collapse; long-term local rights value above peer.",
      stadium: "Oracle Park (2000, $357M) — privately financed (only post-1990s MLB stadium 100% private); Oracle 20-year naming deal; team-owned with bay-front waterfront premium; Mission Rock adjacent development underway.",
      brand: "3 World Series titles in 5 years (2010/12/14) defined dynasty era; Bonds-era national brand still resonates.",
      marketSize: "San Francisco DMA #6 — affluent tech corporate base; Bay Area combined sports market is largest west of Chicago.",
      onField: "Devers acquired Jan 2025 from Red Sox; post-dynasty rebuild has produced inconsistent results; Sixth Street 10% stake (2025) signals long-term operational support.",
    },
  },

  "San Diego Padres": {
    extendedValuationHistory: [
      { year: 1998, value: 0.185, source: "Forbes" },
      { year: 2000, value: 0.197, source: "Forbes" },
      { year: 2002, value: 0.207, source: "Forbes" },
      { year: 2004, value: 0.305, source: "Forbes" },
      { year: 2006, value: 0.367, source: "Forbes" },
      { year: 2008, value: 0.401, source: "Forbes" },
      { year: 2010, value: 0.408, source: "Forbes" },
      { year: 2012, value: 0.458, source: "Forbes" },
      { year: 2014, value: 0.600, source: "Forbes" },
      { year: 2015, value: 0.890, source: "Forbes" },
      { year: 2016, value: 0.940, source: "Forbes" },
      { year: 2017, value: 1.125, source: "Forbes" },
      { year: 2018, value: 1.270, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Padres pioneered direct-to-consumer streaming after Bally Sports San Diego collapsed Q2 2024; team-controlled distribution generates ~$100M local revenue, validating model for other MLB teams.",
      stadium: "Petco Park (2004) — public-private ($301M public/$153M private); East Village location anchors downtown San Diego revival; team-controlled non-game programming.",
      brand: "Strong Southern California secondary market; brown-and-gold rebrand (2020) revived merchandise; Tony Gwynn legacy.",
      marketSize: "San Diego DMA #28 but tourism/military/biotech corporate base supports premium pricing; Mexican border market potential.",
      onField: "Manny Machado / Tatis Jr / Bogaerts / Darvish locked through 2032+; sustained $230M+ payroll under late Peter Seidler; pending sale process at $3.9B implied could reset franchise.",
    },
  },

  "Colorado Rockies": {
    extendedValuationHistory: [
      { year: 1998, value: 0.305, source: "Forbes" },
      { year: 2000, value: 0.286, source: "Forbes" },
      { year: 2002, value: 0.347, source: "Forbes" },
      { year: 2004, value: 0.298, source: "Forbes" },
      { year: 2006, value: 0.298, source: "Forbes" },
      { year: 2008, value: 0.371, source: "Forbes" },
      { year: 2010, value: 0.384, source: "Forbes" },
      { year: 2012, value: 0.464, source: "Forbes" },
      { year: 2014, value: 0.575, source: "Forbes" },
      { year: 2015, value: 0.855, source: "Forbes" },
      { year: 2016, value: 1.000, source: "Forbes" },
      { year: 2017, value: 1.200, source: "Forbes" },
      { year: 2018, value: 1.225, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "AT&T SportsNet Rocky Mountain dissolved 2023; Rockies on MLB Local Media DTC platform; among the steepest local revenue declines in baseball.",
      stadium: "Coors Field (1995) — Denver Metropolitan Major League Baseball Stadium District, public-funded; team has long-term lease; unique high-altitude park dynamics drive offense.",
      brand: "Niche regional brand; never won World Series (1 NL pennant 2007); merchandise indexes near league bottom.",
      marketSize: "Denver DMA #16 — fast-growing; only big-league team in Mountain West region creates territorial monopoly across multiple states.",
      onField: "Multi-year rebuild without clear franchise centerpiece; Kris Bryant 7yr/$182M (2022) has been an injury-plagued contract disaster; Walton-Penner 40% stake (2024) brings KSE/Rams ownership influence.",
    },
  },

  "Arizona Diamondbacks": {
    extendedValuationHistory: [
      { year: 1998, value: 0.250, source: "Forbes" },
      { year: 2000, value: 0.273, source: "Forbes" },
      { year: 2002, value: 0.280, source: "Forbes" },
      { year: 2004, value: 0.286, source: "Forbes" },
      { year: 2006, value: 0.305, source: "Forbes" },
      { year: 2008, value: 0.379, source: "Forbes" },
      { year: 2010, value: 0.379, source: "Forbes" },
      { year: 2012, value: 0.447, source: "Forbes" },
      { year: 2014, value: 0.585, source: "Forbes" },
      { year: 2015, value: 0.840, source: "Forbes" },
      { year: 2016, value: 1.025, source: "Forbes" },
      { year: 2017, value: 1.150, source: "Forbes" },
      { year: 2018, value: 1.210, source: "Forbes" },
    ],
    factorNarratives: {
      mediaRights: "Bally Sports Arizona collapsed; D-backs on MLB Local Media DTC; among smallest local TV revenues in baseball; Apple TV / national share critical.",
      stadium: "Chase Field (1998) — Maricopa County owned; lease expires 2027; Kendrick has signaled team needs $500M+ in renovations or new stadium — major near-term valuation event.",
      brand: "2001 World Series title is foundational; modern brand reset with sleek logo refresh (2024); strong Phoenix-area engagement.",
      marketSize: "Phoenix DMA #11 — fast-growing Sun Belt; corporate base diversified (PetSmart, GoDaddy, Republic Services).",
      onField: "2023 NL pennant + World Series appearance reset franchise narrative; Carroll/Gallen/Marte locked core; sustained postseason competitiveness possible if stadium issue resolved.",
    },
  },

};
